import request from "@/utils/request";


export function certAddList(params) {
    return request({
        url: '/app/cert/add/list',
        method: 'get',
        params
    })
}
export function certDeleteList(params) {
    return request({
        url: '/app/cert/delete/list',
        method: 'get',
        params
    })
}
export function certResignList(params) {
    return request({
        url: '/app/cert/resign/list',
        method: 'get',
        params
    })
}

export function certAddGet(params) {
    return request({
        url: '/app/cert/add/get',
        method: 'get',
        params
    })
}
export function certDeleteGet(params) {
    return request({
        url: '/app/cert/delete/get',
        method: 'get',
        params
    })
}
export function certResignGet(params) {
    return request({
        url: '/app/cert/resign/get',
        method: 'get',
        params
    })
}
export function certViewUrl(params) {
    return request({
        url: '/app/cert/getViewUrl',
        method: 'get',
        params
    })
}

export function certSignUrl(params) {
    return request({
        url: '/app/cert/getSignUrl',
        method: 'get',
        params
    })
}

export function certAddSteps(params) {
    return request({
        url: '/app/cert/add/steps',
        method: 'get',
        params
    })
}

export function certWorkSubmit(data) {
    return request({
        url: '/app/cert/work/submit',
        method: 'post',
        data
    })
}

export function certWorkGet(id) {
    return request({
        url: '/app/cert/work/get',
        method: 'get',
        params: {id}
    })
}

export function certWorkCancel(params) {
    return request({
        url: '/app/cert/work/cancel',
        method: 'get',
        params: params
    })
}

export function certWorkList(params) {
    return request({
        url: '/app/cert/work/list',
        method: 'get',
        params
    })
}


export function certIncomeSubmit(data) {
    return request({
        url: '/app/cert/income/submit',
        method: 'post',
        data
    })
}

export function certIncomeGet(id) {
    return request({
        url: '/app/cert/income/get',
        method: 'get',
        params: {id}
    })
}

export function certIncomeCancel(params) {
    return request({
        url: '/app/cert/income/cancel',
        method: 'get',
        params: params
    })
}

export function certIncomeList(params) {
    return request({
        url: '/app/cert/income/list',
        method: 'get',
        params
    })
}

export function certLeaveSubmit(data) {
    return request({
        url: '/app/cert/leave/submit',
        method: 'post',
        data
    })
}

export function certLeaveGet(id) {
    return request({
        url: '/app/cert/leave/get',
        method: 'get',
        params: {id}
    })
}

export function certLeaveCancel(params) {
    return request({
        url: '/app/cert/leave/cancel',
        method: 'get',
        params: params
    })
}

export function certLeaveList(params) {
    return request({
        url: '/app/cert/leave/list',
        method: 'get',
        params
    })
}

export function getDocFileId(params) {
    return request({
        url: '/app/cert/getDocFileId',
        method: 'get',
        params
    })
}